(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocuvela-eye-massager-hero"] && !Shopify.designMode) return;
  try {
    
  const countdowns = document.querySelectorAll('[data-ocuvela-countdown]');
  countdowns.forEach((countdown) => {
    const output = countdown.querySelector('strong');
    const end = new Date(countdown.dataset.ocuvelaCountdown).getTime();
    const update = () => {
      const remaining = Math.max(0, end - Date.now());
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      output.textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };
    update();
    window.setInterval(update, 1000);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.ocuvela-hero form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      const added = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', body: new FormData(form) });
      if (!added.ok) throw new Error('Cart add failed');
      const sections = await fetch(`${window.location.pathname}?sections=cart-drawer-section`).then((response) => response.json());
      const current = document.getElementById('shopify-section-cart-drawer-section');
      if (current && sections['cart-drawer-section']) current.outerHTML = sections['cart-drawer-section'];
      document.querySelector('#cart-drawer')?.open();
    } finally {
      if (button) button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zivo-reference-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-zivo-countdown]').forEach((timer) => {
    const end = new Date(timer.dataset.zivoCountdown).getTime();
    const output = timer.querySelector('strong');
    const update = () => { const time = Math.max(0, end - Date.now()); const minutes = Math.floor(time / 60000); const seconds = Math.floor((time % 60000) / 1000); output.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`; };
    update(); window.setInterval(update, 1000);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.zivo-hero__form'); if (!form) return;
    event.preventDefault(); const button = form.querySelector('button'); if (button) button.disabled = true;
    try { const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', body: new FormData(form) }); if (!response.ok) throw new Error('cart-add-failed'); const sections = await fetch(`${window.location.pathname}?sections=cart-drawer-section`).then((result) => result.json()); const drawer = document.getElementById('shopify-section-cart-drawer-section'); if (drawer && sections['cart-drawer-section']) drawer.outerHTML = sections['cart-drawer-section']; document.querySelector('#cart-drawer')?.open(); } finally { if (button) button.disabled = false; }
  });

  } catch(e) { console.error(e); }
})();
})();
